import React from 'react';

const Blogs = () => {
    return (
        <div className="bg-dark" style={{ minHeight: "100vh" }}>
            <h1 className="mt-5 pt-5 text-center text-white text-uppercase">Blogs are coming soon!</h1>
        </div>
    );
};

export default Blogs;